module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-12.cf7bb80b.png";